import { put, call, all, takeLatest, select } from "redux-saga/effects";
import * as TYPES from "./clinicTypes";
import * as clinicApi from "./clinicAPIs";
import { getBaseUrl } from "~/utils/getBaseUrl";

function* getAllClinicWorker({ data }) {
  try {
    yield put({ type: TYPES.SHOW_LOADING });
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(clinicApi.getAllClinic, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");
    if (response.data.error_message)
      throw new Error(response.data.error_message);
    yield put({ type: TYPES.GET_ALL_CLINIC_SUCCESS, data: response.data.data });
    yield put({ type: TYPES.HIDE_LOADING });
  } catch (error) {
    yield put({
      type: TYPES.GET_ALL_CLINIC_FAILURE,
      errorMessage: error.message || error
    });
    yield put({ type: TYPES.HIDE_LOADING });
  }
}

function* getClinicDetailByDateWorker({ data }) {
  try {
    yield put({ type: TYPES.SHOW_LOADING });
    yield put({ type: TYPES.SELECT_CLINIC, date: data.date });
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(clinicApi.getDetailByDateClinic, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");
    if (response.data.error_message)
      throw new Error(response.data.error_message);
    yield put({
      type: TYPES.GET_DETAIL_CLINIC_BY_DATE_SUCCESS,
      data: response.data.data
    });
    yield put({ type: TYPES.HIDE_LOADING });
  } catch (error) {
    yield put({
      type: TYPES.GET_DETAIL_CLINIC_BY_DATE_FAILURE,
      errorMessage: error.message || error
    });
    yield put({ type: TYPES.HIDE_LOADING });
  }
}

export default function* watcher() {
  yield all([
    takeLatest(TYPES.GET_ALL_CLINIC_REQUEST, getAllClinicWorker),
    takeLatest(
      TYPES.GET_DETAIL_CLINIC_BY_DATE_REQUEST,
      getClinicDetailByDateWorker
    )
  ]);
}
